import React from 'react';
import classNames from 'classnames';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const DeviceStatusFinalReviewScreen = (props) => {
  const {
    deviceId,
    machineId,
    selectedMachineStatus,
    selectedCycleName,
    selectedModifierName,
    onBack,
    onNext,
    disableFinalSubmitButton,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Final data for simulating device status events</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Please reviews the final details to ensure your selections look good!</p>
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Device ID: </p>
            <p>{deviceId}</p>
          </div>
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Machine ID: </p>
            <p>{machineId}</p>
          </div>
          {selectedMachineStatus && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Status selected: </p>
              <p>{selectedMachineStatus}</p>
            </div>
          )}
          {selectedCycleName && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Cycle selected: </p>
              <p>{selectedCycleName}</p>
            </div>
          )}
          {selectedModifierName && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Modifier selected: </p>
              <p>{selectedModifierName}</p>
            </div>
          )}
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !disableFinalSubmitButton,
          })}
          disabled={!disableFinalSubmitButton}
          onClick={onNext}
        >
          Submit
        </button>
      </footer>
    </>
  );
};

export default DeviceStatusFinalReviewScreen;
